//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apiConst from '../service/api/api-const'
    export default{
        name:'christmas_form_seven_detail',
        data(){
            return{
                get_host:host.host,
                host:apiConst.host,
                newFile:[],
                form:{
                    hecklist:[],
                    // intermediate_nurse_sign:'',
                    // senior_nurse:''
                },
                
                showSignature:true,
                showCSignature:true,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            goEdit(){
                this.$router.push({
                    path:'christmas_form_seven_edit', 
                    query:{
                        id:this.$route.query.id,
                        tabVal: this.$route.query.tabVal,
                    }
                })
            },
            saveCName(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.intermediate_nurse_sign = encodeURI(png)
                this.showCSignature = true
            },
            editCName(){
                this.showCSignature = false
                 this.form.intermediate_nurse_sign = ''
            },
            clearCName(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.intermediate_nurse_sign = ''
            },
            saveName(){
                let signature ='signature2'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.senior_nurse = encodeURI(png)
                this.showSignature = true
            },
            editName(){
                this.showSignature = false
                 this.form.senior_nurse = ''
            },
            clearName(){
                let signature ='signature2'
                let refs = this.$refs[signature].clear()
                this.form.senior_nurse = ''
            },
            submitForm(){
                console.info("this.form.hecklist",this.form.hecklist)
                console.info("this.newFile",this.newFile)
                if(this.form.hecklist.length==0&&this.newFile.length==0){
                    this.$vux.toast.show({
                            type: 'cancel',
                            text: '至少上传一张图片',
                    })
                    return
                }
                if(this.form.intermediate_nurse_sign==''){
                    this.$vux.toast.show({
                            type: 'cancel',
                            text: '缺少中级护理师签字',
                    })
                    return
                }
                if(this.form.senior_nurse==''){
                    this.$vux.toast.show({
                            type: 'cancel',
                            text: '缺少护理长签字',
                    })
                    return
                }
                let params={
                    token:this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id:this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    intermediate_nurse_sign:this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host,'') : this.form.intermediate_nurse_sign,
                    senior_nurse:this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host,'') : this.form.senior_nurse,
                    hecklist:this.form.hecklist
                }
                console.log(params)
                let files=this.newFile
                Api.otherFormApi.updateMaternalHospitalChecklistRecord(params,files,'hecklist').then ( res => {
                    if(res.errcode==200){
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                tabVal: this.$route.query.tabVal,
                                name : 'christmas_form_seven_edit',
                            }
                        })
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            },
            //图片上传
            fileImage(e){
                var file = e.target.files[0];
                var that=this;
                lrz(file)
                .then(function (rst) {
                    // 处理成功会执行
                    let newLen= that.newFile.length+that.form.hecklist.length
                    if(that.newFile.length == 6){
                        that.$vux.toast.show({
                            type: 'cancel',
                            text: '一次最多上传6张图片',
                        })
                        return
                    }
                    if(newLen==30){
                        that.$vux.toast.show({
                            type: 'cancel',
                            text: '最多上传30张图片',
                        })
                        return
                    }
                    that.newFile.push(rst)
                    console.info(that.newFile)
                })
                .catch(function (err) {
                    console.info(err)
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '网络错误',
                    })
                    // 处理失败会执行
                })
            },
            //删除图片
            delImg(file){
                if(file.base64){
                    for(var i=0;i<this.newFile.length;i++){  
                        if(file.base64==this.newFile[i].base64){
                            this.newFile.splice(i,1)
                        }
                    }
                }else{
                    for(var i=0;i<this.form.hecklist.length;i++){  
                        if(file==this.form.hecklist[i]){
                            this.form.hecklist.splice(i,1)
                        }
                    }
                }
                
            },
            //转base64
            convertBase64UrlToBlob(urlData) {
                var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
                //处理异常,将ascii码小于0的转换为大于0
                var ab = new ArrayBuffer(bytes.length);
                var ia = new Uint8Array(ab);
                for(var i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                return new Blob([ab], {
                    type: 'image/png'
                });
            }
        },
        created(){
           let params={
                token:this.$cookie.get('token'),
                number_id:this.$cookie.get('id'),
                maternal_info_id:this.$route.query.id,
                store_id:this.$cookie.get('store_id'),
           }
           Api.otherFormApi.getMaternalHospitalChecklistRecord(params).then ( res => {
               console.info("出院就诊详情",res)
               if(res.errcode==200){
                   this.form=res.data
                   this.form.intermediate_nurse_sign=res.data.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? res.data.intermediate_nurse_sign : this.get_host+res.data.intermediate_nurse_sign
                   this.form.senior_nurse=res.data.senior_nurse.indexOf(this.get_host) != -1 ? res.data.senior_nurse : this.get_host+res.data.senior_nurse
               }
            })
        }
    }



// WEBPACK FOOTER //
// ./src/components/christmas_form_seven_edit.vue